
export const K: number = 1024
export const M: number = 1024 * K
export const G: number = 1024 * M
